module.exports = __webpack_public_path__ + "img/lasosta.3cbc5846.jpeg";